import api, { createApiService } from "../http";
import { BaseRequest, RequestGetAll } from "../types/services-types/http-types";
import { IProgrammMinfin } from "../types/services-types/programms-minfin";
import { IFinStatsForUser, ITransaction, SendMoneysFromCurrentMinfinToAccountMinfinRequest } from "../types/services-types/transaction-types";



export default class TransactionService {

    static apiTransactionService = createApiService('/transaction')

    static async Create(amount: string | number, currency: string) {
        const response = await this.apiTransactionService.post(`/create`, {
            amount,
            currency 
        })
        return response.data
    }

    static async CreateForForm(amount: string | number, currency: string) {
        const response = await this.apiTransactionService.post(`/create-for-form`, {
           amount,
           currency 
        })
        return response.data
    }

    static async SendCurrencySiteToUserRequest(amount: string | number, message: string, to: number, compound_subject_rights_id: string | number = null, splitted: boolean = false) {
        const response = await this.apiTransactionService.post(`/send-moneys-to-user`, {
           amount,
           message,
           to,
           compound_subject_rights_id,
           splitted
         })
         return response.data
    }

    static async SendCurrencySiteToUserFinish(id: string, code: number | string) {
        const response = await this.apiTransactionService.post(`/send-moneys-to-user-finish`, {
          id,
          code
         })
        return response.data
    }

    static async RequestNewCodeForSendCurrencySiteToUser(id: string) {
        const response = await this.apiTransactionService.get(`/send-moneys-to-user-new-code`, {
            params: {
                id
            }
        })
        return response.data
    }

    static async SendMoneysToMinfinFromReserveBalance() {
        const response = await this.apiTransactionService.post<BaseRequest<null>>('/send-moneys-to-minfin')
        return response.data
    }

    static async SendMoneysFromMinfinToMinfinAccount() {
        const response = await this.apiTransactionService.post<BaseRequest<null>>('/send-moneys-from-minfin-to-minfin-account')
        return response.data
    }

    static async SendMoneysFromMinfinCurrentToMinfinAccount(form: SendMoneysFromCurrentMinfinToAccountMinfinRequest) {
        const response = await this.apiTransactionService.post<BaseRequest<IProgrammMinfin[]>>('/send-moneys-from-minfin-current-to-minfin-account', form)
        return response.data
    }



    static async Get(id: number | string) {
        const response = await this.apiTransactionService.get<ITransaction>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number | string, page: number | string) {
        const response = await this.apiTransactionService.get<RequestGetAll<ITransaction[]>>(`/all`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetStatsForUser(from_date: string, to_date: string) {
        const response = await this.apiTransactionService.get<IFinStatsForUser[]>('/stats-for-user', {
            params: {
                from_date,
                to_date
            }
            
        })
        return response.data
    }

    static async GetAllFilters(search: string, minAmount: string | number, maxAmount: string | number, typeTransaction: string, currency: string, sortDate: "DESC" | "ASC" = 'DESC', limit: number | string = 100, page: number | string = 0) {
        const response = await this.apiTransactionService.get<RequestGetAll<ITransaction[]>>(`/filters`, {
            params: {
                search,
                minAmount,
                maxAmount,
                typeTransaction,
                currency,
                sortDate,
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllMinfin(search: string, minAmount: string | number, maxAmount: string | number, currency: string, sortDate: "DESC" | "ASC" = 'DESC', limit: number | string = 100, page: number | string = 0) {
        const response = await this.apiTransactionService.get<RequestGetAll<ITransaction[]>>(`/all-minfin`, {
            params: {
                search,
                minAmount,
                maxAmount,
                currency,
                sortDate,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number | string) {
        const response = await this.apiTransactionService.get<BaseRequest<null>>(`/delete/${id}`)
        return response.data
    }
}